import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=0ffcc103&scoped=true&"
import script from "./integralDetails.vue?vue&type=script&lang=js&"
export * from "./integralDetails.vue?vue&type=script&lang=js&"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=0ffcc103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffcc103",
  null
  
)

export default component.exports